
import { SearchTravelResult } from '@/types/models'
import { defineComponent, PropType } from 'vue'

import TravelArticle from '@/components/TravelList/TravelArticle.vue';
import { LocaleStrings } from '@/types/paramModels';

export default defineComponent({
    name: "TravelList",
    components: {
        TravelArticle
    },
    props: {
        travels: {
            type: Array as PropType<Array<SearchTravelResult>>,
            required: true
        },
        pageTexts: {
            type: Object,
            required: true
        },
        localeStrings: {
            type: Object as PropType<LocaleStrings>,
            required: true
        }
    },
})
